import * as z from "zod";

/**
 * Recent Temporal runs of the onboarding ingest + recompute workflows.
 * Powers the "Recent runs" panel on the Sync tab so admins can see
 * what the schedule (or manual triggers) actually did, without jumping
 * to Temporal UI.
 */
export const getOnboardingWorkflowRunsInputSchema = z.object({
  /** Max runs to return. Default 30. */
  limit: z.number().int().min(1).max(100).default(30),
});
export type GetOnboardingWorkflowRunsInput = z.infer<
  typeof getOnboardingWorkflowRunsInputSchema
>;

const runSchema = z.object({
  workflowId: z.string(),
  runId: z.string(),
  workflowType: z.string(),
  status: z.enum([
    "running",
    "completed",
    "failed",
    "canceled",
    "terminated",
    "continued_as_new",
    "timed_out",
    "unknown",
  ]),
  startedAt: z.date().nullable(),
  closedAt: z.date().nullable(),
  /** Milliseconds from startedAt to closedAt. Null if still running. */
  durationMs: z.number().int().min(0).nullable(),
  historyLength: z.number().int().min(0).nullable(),
});
export type OnboardingWorkflowRun = z.infer<typeof runSchema>;

export const getOnboardingWorkflowRunsOutputSchema = z.object({
  runs: z.array(runSchema),
});
export type GetOnboardingWorkflowRunsOutput = z.infer<
  typeof getOnboardingWorkflowRunsOutputSchema
>;

export const getOnboardingWorkflowRuns = {
  name: "getOnboardingWorkflowRuns" as const,
  input: getOnboardingWorkflowRunsInputSchema,
  output: getOnboardingWorkflowRunsOutputSchema,
};
